import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditBranch() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/BranchLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Branch"
      alert="Branch Edited Successfully"
      editDataAPIEndPoint={`/Branch/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/Branch/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Branch",
              name: "BL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "BL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        BL_Name: {
          required: true,
          
        },
        BL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditBranch;
